import { createAction } from '@reduxjs/toolkit';

/**
 * Acao global escutada por todos os slices via extraReducers.
 * Cada slice reseta seu state ao initialState quando este action e
 * disparado. Substitui o padrao de importar `resetX` de cada slice nos
 * thunks (que criava ciclos de import).
 */
export const resetAllStores = createAction('app/resetAllStores');

/**
 * Reseta apenas os slices ligados ao plano selecionado (loan + plan +
 * configs). Usado ao trocar de plano sem deslogar.
 */
export const resetPlanScopedStores = createAction('app/resetPlanScopedStores');

/**
 * Define o plano ativo do usuario. Mantido em sharedActions para evitar
 * ciclo de import entre user/slice e user/thunks.
 */
export const setPlanoAtual = createAction('user/setPlanoAtual');
